import axios from '@_system/axios/axios.js'
export default {
	path: 'campaign',
	
	
	actiontask(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/actiontask', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	actionplan(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/actionplan', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	edittask(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/edittask', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listtask(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listtask', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	deletetask(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/deletetask', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	editplan(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/editplan', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listplan(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listplan', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	deleteplan(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/deleteplan', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	pull(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/pull', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updatebase(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updatebase', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/alimama.campaign', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
